import { onlineManager } from "@tanstack/react-query";

/**
 * TanStack Query starts as online and only flips when an `offline` event
 * fires. A hard reload that is already offline never fires that event, so
 * queries look "still loading" instead of paused. Seed the flag from
 * `navigator.onLine` and keep it in sync.
 */
export const syncBrowserOnline = () => {
  onlineManager.setOnline(
    typeof navigator === "undefined" ? true : navigator.onLine,
  );
};

if (typeof window !== "undefined") {
  syncBrowserOnline();
  window.addEventListener("online", syncBrowserOnline);
  window.addEventListener("offline", syncBrowserOnline);
}
